import { render, staticRenderFns } from "./beike-btn.vue?vue&type=template&id=13c918d2&scoped=true"
import script from "./beike-btn.vue?vue&type=script&lang=ts"
export * from "./beike-btn.vue?vue&type=script&lang=ts"
import style0 from "./beike-btn.vue?vue&type=style&index=0&id=13c918d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c918d2",
  null
  
)

export default component.exports